module.exports = __webpack_public_path__ + "static/media/time-color.6ff61109.svg";